import React, { useEffect, useRef, useState } from "react";
import { motion } from "framer-motion";
import { FaUser, FaEnvelope } from "react-icons/fa";
import { IoIosPaper } from "react-icons/io";
import { MdWork, MdOutlineClose } from "react-icons/md";
import { SiGooglechat } from "react-icons/si";
import Left from "./components/home/Left";
import About from "./components/about/About";
import Resume from "./components/resume/Resume";
import Projects from "./components/projects/Projects";
import Blog from "./components/blog/Blog";
import Contact from "./components/contact/Contact";
import Sidenav from "./components/home/sidenav/Sidenav";

function resetSctollPosition() {
  const scrollItem = document.getElementById("scroll-item");
  if (scrollItem) {
    scrollItem.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }
}

const Home = () => {
  resetSctollPosition();

  const [about, setAbout] = useState(true);
  const [resume, setResume] = useState(false);
  const [projects, setProjects] = useState(false);
  const [blog, setBlog] = useState(false);
  const [contact, setContact] = useState(false);
  const [sidenav, setSidenav] = useState(false);
  const ref = useRef();
  const contactRef = useRef();

  useEffect(() => {
    const handleContactClick = () => {
      setAbout(false);
      setResume(false);
      setProjects(false);
      setBlog(false);
      setContact(true);

      setTimeout(() => {
        if (contactRef.current) {
          const offset = 80;
          const bodyRect = document.body.getBoundingClientRect().top;
          const elementRect = contactRef.current.getBoundingClientRect().top;
          const elementPosition = elementRect - bodyRect;
          const offsetPosition = elementPosition - offset;

          window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
          });
        }
      }, 150);
    };

    window.addEventListener('scrollToContact', handleContactClick);

    return () => {
      window.removeEventListener('scrollToContact', handleContactClick);
    };
  }, []);

  useEffect(() => {
    document.body.addEventListener("click", (e) => {
      if (e.target.contains(ref.current)) {
        setSidenav(false);
      }
    });
  }, []);

  return (
    <div className="w-full lgl:w-[85%] h-full lgl:h-[85%] bg-transparent text-gray-800 z-50 flex items-start justify-between p-4 lgl:p-0 min-h-[650px]">
      <div className="w-16 h-96 bg-transparent hidden lgl:flex flex-col gap-4">

        {sidenav && (
          <div className="w-full h-screen fixed top-0 left-0 bg-black bg-opacity-30 z-50 backdrop-blur-sm">
            <div className="w-96 h-full relative">
              <motion.div
                ref={ref}
                initial={{ x: -500, opacity: 0 }}
                animate={{ x: 0, opacity: 1 }}
                transition={{ duration: 0.3 }}                
                className="w-full h-full bg-white overflow-y-scroll scrollbar-thin scrollbar-thumb-gray-300"
                style={{ background: "rgba(59, 130, 246, 0.1)" }}
              >
                <Sidenav />
                <span
                  onClick={() => setSidenav(false)}
                  className="absolute top-0 -right-16 w-12 h-12 bg-white text-2xl text-gray-600 hover:text-blue-500 duration-300 cursor-pointer flex items-center justify-center z-50 shadow-md rounded-full"
                >
                  <MdOutlineClose />
                </span>
              </motion.div>
            </div>
          </div>
        )}

        <div
          className="w-full h-80 bg-white rounded-3xl flex flex-col items-center justify-between py-6 shadow-md"
          style={{ background: "rgba(59, 130, 246, 0.1)" }}
        >
          <span
            onClick={() => {
              setAbout(true);
              setResume(false);
              setProjects(false);
              setBlog(false);
              setContact(false);
            }}
            className={`w-full h-6 text-xl flex items-center justify-center cursor-pointer relative group ${
              about ? "text-blue-500" : "text-gray-600 hover:text-blue-500"
            }`}
          >
            <FaUser />
            <span className="text-white font-medium text-xs uppercase bg-blue-500 px-4 py-[1px] rounded-xl absolute left-0 translate-x-8 group-hover:translate-x-12 opacity-0 group-hover:opacity-100 transition-all duration-300 z-20">
              About
            </span>
          </span>

          <span
            onClick={() => {
              setAbout(false);
              setResume(true);
              setProjects(false);
              setBlog(false);
              setContact(false);
            }}
            className={`w-full h-6 text-xl flex items-center justify-center cursor-pointer relative group ${
              resume ? "text-purple-500" : "text-gray-600 hover:text-purple-500"
            }`}
          >
            <IoIosPaper />
            <span className="text-white font-medium text-xs uppercase bg-purple-500 px-4 py-[1px] rounded-xl absolute left-0 translate-x-8 group-hover:translate-x-12 opacity-0 group-hover:opacity-100 transition-all duration-300 z-20">
              Resume
            </span>
          </span>

          <span
            onClick={() => {
              setAbout(false);
              setResume(false);
              setProjects(true);
              setBlog(false);
              setContact(false);
            }}
            className={`w-full h-6 text-xl flex items-center justify-center cursor-pointer relative group ${
              projects ? "text-blue-500" : "text-gray-600 hover:text-blue-500"
            }`}
          >
            <MdWork />
            <span className="text-white font-medium text-xs uppercase bg-blue-500 px-4 py-[1px] rounded-xl absolute left-0 translate-x-8 group-hover:translate-x-12 opacity-0 group-hover:opacity-100 transition-all duration-300 z-20">
              Projects
            </span>
          </span>

          <span
            onClick={() => {
              setAbout(false);
              setResume(false);
              setProjects(false);
              setBlog(true);
              setContact(false);
            }}
            className={`w-full h-6 text-xl flex items-center justify-center cursor-pointer relative group ${
              blog ? "text-purple-500" : "text-gray-600 hover:text-purple-500"
            }`}
          >
            <SiGooglechat />
            <span className="text-white font-medium text-xs uppercase bg-purple-500 px-4 py-[1px] rounded-xl absolute left-0 translate-x-8 group-hover:translate-x-12 opacity-0 group-hover:opacity-100 transition-all duration-300 z-20">
              Blog
            </span>
          </span>

          <span
            onClick={() => window.dispatchEvent(new Event('scrollToContact'))}
            className={`w-full h-6 text-xl flex items-center justify-center cursor-pointer relative group ${
              contact ? "text-blue-500" : "text-gray-600 hover:text-blue-500"
            }`}
          >
            <FaEnvelope />
            <span className="text-white font-medium text-xs uppercase bg-blue-500 px-4 py-[1px] rounded-xl absolute left-0 translate-x-8 group-hover:translate-x-12 opacity-0 group-hover:opacity-100 transition-all duration-300 z-20">
              Contact
            </span>
          </span>
        </div>
      </div>

      <div className="w-full lgl:w-[94%] h-full flex flex-col gap-6 lgl:gap-0 lgl:flex-row items-center">
        <Left />

        <div
          className="w-full lgl:w-8/12 h-[95%] bg-white rounded-2xl flex justify-center items-center shadow-md"
          style={{ background: "rgba(59, 130, 246, 0.1)" }}
        >
          <div className="w-full h-full lgl:hidden bg-transparent rounded-2xl flex flex-col gap-6">
            <About />
            <Resume />
            <Projects />
            <Blog />
            <Contact />
          </div>

          <div id="scroll-item" className="w-full h-[96%] hidden lgl:flex justify-center overflow-y-scroll scrollbar-thin scrollbar-thumb-gray-300">
            {about && (
              <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 0.3 }}
              >
                <About />
              </motion.div>
            )}

            {resume && (
              <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 0.3 }}
              >
                <Resume />
              </motion.div>
            )}

            {projects && (
              <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 0.3 }}
              >
                <Projects />
              </motion.div>
            )}

            {blog && (
              <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 0.3 }}
              >
                <Blog />
              </motion.div>
            )}

            {contact && (
              <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 0.3 }}
              >
                <div ref={contactRef}>
                  <Contact />
                </div>
              </motion.div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home;
